// extracted by mini-css-extract-plugin
export default {"container":"Tabs_container__kQ4Hq","tab":"Tabs_tab__IsubT","selected":"Tabs_selected__ATra9","disabled":"Tabs_disabled__Rwmev"};